import axios from "axios";
import authHeader from "./auth-header";
import setupInterceptors from "./setupInterceptors";

const prod = process.env.NODE_ENV === "production";
export default () => {
  const instance = axios.create({
    baseURL: prod
      ? "https://api.umaycicekcilik.com/api"
      : "https://localhost:7286/api",
    //"https://delphinpiraye.net/api"
    //: "https://delphinpiraye.net/api",
    headers: authHeader(),
  });
  setupInterceptors(instance);
  return instance;
};
